// Carousels Model Series
const swiperModelSeries = new Swiper(".swiper--in-tab", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  loop: true,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

$('.modelSeriesWrapper').each(function () {
    const $wrapper = $(this);
    const $swiper = $wrapper.find('.swiper')[0].swiper;
    const $navLinks = $wrapper.find('.nav-tabs .nav-link');
    const $slides = $wrapper.find('.swiper-slide');

    // Handle slide change
    $swiper.on('slideChange', function () {
        const activeType = $swiper.slides[$swiper.activeIndex].getAttribute('data-type');
        $navLinks.removeClass('active').filter(`[data-type="${activeType}"]`).addClass('active');
    });

    // Handle navigation tab click
    $navLinks.on('click', function (e) {
        e.preventDefault();
        const type = $(this).attr('data-type');
        const slideIndex = $slides.filter(`[data-type="${type}"]`).index();
        $swiper.slideTo(slideIndex);
    });
});
